import React from 'react';
import UserPickerField from '../../common/ui/fields/base-fields/user-picker-field/index.tsx';
import type { UserPickerFieldProps } from '../../common/ui/fields/base-fields/user-picker-field/types.tsx';

const MultiUserPickerField = (props: Omit<UserPickerFieldProps, 'isMulti' | 'context'>) => (
	<UserPickerField {...props} isMulti context="CustomMultiUserField" />
);

export default MultiUserPickerField;
